(function () {
    'use strict';

    angular.module('app',
        [
            'app.sales',
            'app.cart',
            'app.general',
            'app.customer',
            'app.core'
        ]);
})();